import { normalizeForSearch, textIncludesQuery } from '@narrativebench/editor-core';

function splitCamelCaseWords(rest: string): string[] {
  const spaced = rest
    .replace(/([a-z\d])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2');
  return spaced
    .split(/\s+/)
    .map((w) => w.toLowerCase())
    .filter(Boolean);
}

const ICON_PART_SYNONYMS: Record<string, string> = {
  pen: 'pluma bolígrafo',
  nib: 'punta pluma',
  book: 'libro lectura',
  books: 'libros',
  menu: 'menú',
  stories: 'cuentos historias historias',
  article: 'artículo',
  description: 'descripción',
  note: 'nota',
  notes: 'notas',
  sticky: 'postit',
  folder: 'carpeta',
  library: 'biblioteca',
  class: 'clase',
  feed: 'feed actualidad',
  newspaper: 'periódico prensa',
  draw: 'dibujar dibujo',
  create: 'crear',
  brush: 'brocha pintura',
  palette: 'paleta colores',
  design: 'diseño',
  architecture: 'arquitectura',
  color: 'color',
  lens: 'lente',
  gesture: 'gesto',
  format: 'formato',
  paint: 'pintura',
  voice: 'voz',
  speaker: 'altavoz',
  chat: 'chat',
  message: 'mensaje',
  comment: 'comentario',
  review: 'reseña',
  forum: 'foro',
  star: 'estrella',
  favorite: 'favorito corazón',
  lightbulb: 'bombilla idea',
  tips: 'consejos',
  bolt: 'rayo',
  flare: 'destello',
  awesome: 'genial',
  psychology: 'psicología',
  improvement: 'mejora',
  theater: 'teatro',
  comedy: 'comedia',
  masks: 'máscaras',
  sentiment: 'sentimiento',
  satisfied: 'contento',
  dissatisfied: 'disgustado',
  mood: 'ánimo',
  emoji: 'emoji',
  emotions: 'emociones',
  face: 'cara',
  person: 'persona',
  people: 'gente personas',
  groups: 'grupos',
  child: 'niño',
  care: 'cuidado',
  elderly: 'anciano',
  accessibility: 'accesibilidad',
  giftcard: 'tarjeta regalo',
  gift: 'regalo',
  cake: 'pastel tarta',
  celebration: 'fiesta celebración',
  history: 'historia',
  schedule: 'horario',
  event: 'evento',
  today: 'hoy',
  calendar: 'calendario',
  date: 'fecha',
  range: 'rango',
  castle: 'castillo',
  home: 'casa hogar',
  cottage: 'cabaña',
  apartment: 'apartamento',
  city: 'ciudad',
  balance: 'banco edificio',
  museum: 'museo',
  school: 'escuela colegio',
  church: 'iglesia',
  mosque: 'mezquita',
  temple: 'templo',
  synagogue: 'sinagoga',
  stadium: 'estadio',
  hospital: 'hospital',
  police: 'policía',
  truck: 'camión bomberos',
  forest: 'bosque',
  park: 'parque',
  terrain: 'terreno',
  landscape: 'paisaje',
  beach: 'playa',
  grass: 'hierba',
  florist: 'floristería',
  yard: 'patio',
  nature: 'naturaleza',
  vintage: 'vintage',
  spa: 'spa',
  water: 'agua',
  waves: 'olas',
  pool: 'piscina',
  anchor: 'ancla',
  cloud: 'nube',
  drama: 'drama',
  sunny: 'sol soleado',
  twilight: 'crepúsculo',
  nights: 'noches',
  stay: 'estancia noche',
  dark: 'oscuro',
  storm: 'tormenta',
  thunderstorm: 'tormenta rayos',
  cold: 'frío',
  snowshoeing: 'nieve',
  hot: 'calor',
  fire: 'fuego',
  explore: 'explorar',
  travel: 'viaje',
  map: 'mapa',
  public: 'público mundo',
  hiking: 'senderismo',
  rocket: 'cohete',
  flight: 'vuelo',
  airplane: 'avión',
  sailing: 'vela',
  boat: 'barco',
  directions: 'direcciones',
  car: 'coche auto',
  bike: 'bici bicicleta',
  train: 'tren',
  subway: 'metro',
  satellite: 'satélite',
  run: 'correr',
  sports: 'deportes',
  fitness: 'gimnasio',
  score: 'marcador',
  events: 'eventos',
  music: 'música',
  piano: 'piano',
  mic: 'micrófono',
  headphones: 'auriculares',
  nightlife: 'vida nocturna',
  kitchen: 'cocina',
  restaurant: 'restaurante',
  local: 'local',
  cafe: 'café',
  wine: 'vino',
  bar: 'bar',
  search: 'buscar búsqueda',
  policy: 'política',
  page: 'página',
  visibility: 'visibilidad',
  eye: 'ojo',
  warning: 'aviso',
  report: 'informe',
  problem: 'problema',
  priority: 'prioridad',
  crisis: 'crisis',
  science: 'ciencia',
  biotech: 'biotecnología',
  manufacturing: 'fabricación',
  memory: 'memoria',
  developer: 'desarrollador',
  board: 'placa',
  electric: 'eléctrico',
  offline: 'sin conexión',
  power: 'energía',
  settings: 'ajustes',
  antenna: 'antena',
  blood: 'sangre',
  monitor: 'monitor',
  heart: 'corazón',
  medication: 'medicación',
  vaccines: 'vacunas',
  safety: 'seguridad',
  grade: 'nota calificación',
  diamond: 'diamante',
  workspace: 'trabajo',
  premium: 'premium',
  military: 'militar',
  tech: 'tecnología',
  medal: 'medalla',
  shield: 'escudo',
  security: 'seguridad',
  vpn: 'vpn',
  key: 'llave',
  lock: 'candado cerradura',
  pets: 'mascotas',
  bug: 'bicho insecto',
  smart: 'inteligente',
  toy: 'juguete',
  esports: 'videojuegos',
  extension: 'extensión',
  category: 'categoría',
  hexagon: 'hexágono',
  change: 'cambio',
  circle: 'círculo',
  square: 'cuadrado',
  bookmark: 'marcador',
  label: 'etiqueta',
  offer: 'oferta',
  flag: 'bandera',
  outlined: 'contorno',
  gas: 'gasolina',
  station: 'estación',
  route: 'ruta',
  straight: 'recto',
  looks: 'número',
  food: 'comida',
  beverage: 'bebida',
  egg: 'huevo',
  outdoor: 'exterior',
  grill: 'parrilla',
  toc: 'índice',
  view: 'vista',
  list: 'lista',
  bulleted: 'viñetas',
  numbered: 'numerada',
  check: 'marca',
  box: 'caja',
  blank: 'vacío',
  checklist: 'lista tareas',
  money: 'dinero',
  currency: 'divisa',
  wallet: 'cartera',
  payments: 'pagos',
  credit: 'crédito',
  card: 'tarjeta',
  monetization: 'monetización',
  savings: 'ahorro',
  price: 'precio',
  receipt: 'recibo',
  point: 'punto',
  sale: 'venta',
  shopping: 'compras',
  cart: 'carrito',
  bag: 'bolsa',
  store: 'tienda',
  atm: 'cajero',
  trending: 'tendencia',
  chart: 'gráfico',
  pie: 'pastel gráfico',
  edit: 'editar',
  mode: 'modo',
  drive: 'unidad',
  rename: 'renombrar',
  border: 'borde',
  quote: 'cita',
  subject: 'asunto',
  text: 'texto',
  fields: 'campos',
  title: 'título',
  add: 'añadir',
  open: 'abierto',
  collections: 'colecciones',
  reader: 'lector',
  chrome: 'chrome',
  services: 'servicios',
  objects: 'objetos',
  alt: 'alternativo',
  supervised: 'supervisado',
  user: 'usuario',
  activism: 'activismo',
  volunteer: 'voluntario',
  wb: '',
  nightsstay: 'noche',
  auto: 'automático',
};

export function getIconSearchHaystack(iconId: string): string {
  const base = iconId.toLowerCase();
  const rest = iconId.replace(/^(Md|Fa)/, '');
  const words = splitCamelCaseWords(rest);
  const synonymParts = words.map((w) => ICON_PART_SYNONYMS[w] ?? '');
  return normalizeForSearch([base, ...words, ...synonymParts].join(' '));
}

export function iconIdMatchesSearchQuery(iconId: string, rawQuery: string): boolean {
  const trimmed = normalizeForSearch(rawQuery.trim());
  if (!trimmed) return true;
  const q = trimmed.replace(/^(md|fa)\s*/i, '').trim();
  if (!q) return true;
  const tokens = q
    .split(/\s+/)
    .map((t) => t.replace(/^(md|fa)/i, ''))
    .filter((t) => t.length > 0);
  if (tokens.length === 0) return true;
  const hay = getIconSearchHaystack(iconId);
  return tokens.every((t) => textIncludesQuery(hay, t));
}
